import { createFilterStore } from './createFilterStore';

export const usePayrollRunFilterStore = createFilterStore({
  page: 1,
  limit: 20,
  search: '',
  status: '',
  periodYear: '',
  periodMonth: '',
  sortBy: 'createdAt',
  sortOrder: 'desc' as const,
});
